/**
 * @file コンポーネント：フル動画ページ症例データコンテンツメインデータ スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledContentlist = styled.ul`
    margin-bottom: 16px;
`;

export const StyledContentlistItem = styled.li`
    display: none;
    position: relative;
    background-color: #25292d;

    // アスペクト比 16:9 を維持しつつ、高さ制限
    aspect-ratio: 16 / 9;
    width: 100%;
    max-height: calc(100vh - 100px); // 上下の余白分などを考慮

    &.is-active {
        display: block;
    }

    video, iframe {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`;
